// extracted by mini-css-extract-plugin
module.exports = {"container":"_3shs_QA","header":"_XLUZjFj","body":"_3eLCcPR","tournamentName":"_1y4SHkS","tournamentDate":"_3qM6JQ1","tournamentTime":"_2PcrbNH","key":"_3-QM77g","value":"_1yWkaek"};